import { render, staticRenderFns } from "./NAO_Profile.vue?vue&type=template&id=449233bc&"
import script from "./NAO_Profile.vue?vue&type=script&lang=js&"
export * from "./NAO_Profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports